import React from 'react';
import './radio-button-group.css';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { RadioButton } from './radio-button';

const RadioButtonGroup = props => {
    const { options, group, onChange, size, checked } = props;

    const radioButtonGroupClasses = classNames({
        'radio-button-group': true,
        'radio-button-group--small': size === 'small',
    });

    return (
        <fieldset className={radioButtonGroupClasses}>
            <legend className="radio-button-group__legend">{group}</legend>
            {options.map(option => (
                <RadioButton
                    key={option.label}
                    label={option.label}
                    group={group}
                    onChange={onChange}
                    addedInfo={option.addedInfo}
                    checked={checked === option.label}
                />
            ))}
        </fieldset>
    );
};

RadioButtonGroup.propTypes = {
    options: PropTypes.array.isRequired,
    group: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    size: PropTypes.oneOf(['small', 'medium']),
};

export { RadioButtonGroup };
